import type { SessionOrigin, SessionUploadedBy } from 'api';
import { formatDate } from 'date';
import { Box, Stack, Typography } from 'ui';

import { AIBadge } from '../../index';
import { formatEvidenceSessionOrigin } from '../../utils/formatEvidenceSessionOrigin';

export const EvidenceSessionSummary = ({
  date,
  origin,
  uploadedBy,
  showAIBadge = false,
}: {
  date: string;
  origin: SessionOrigin;
  uploadedBy: SessionUploadedBy;
  showAIBadge?: boolean;
}) => {
  return (
    <Stack direction="column">
      <Box display="flex" gap={1} alignItems="center">
        <Typography fontWeight="bold">{formatDate(date)}</Typography>
        {showAIBadge ? <AIBadge /> : null}
      </Box>
      <Typography variant="body2">
        {origin ? `${formatEvidenceSessionOrigin(origin)} - ` : null} Uploaded by {uploadedBy?.full_name || 'Anonymous'}
      </Typography>
    </Stack>
  );
};
